import gql from 'graphql-tag'

export const getMenuUsuarioGql = gql`
  query GetMenuUsuario {
    menuUsuarioLogado {
      title
      theme
      productName
      currentProduct
      linkHelpTec
      linkPortal
      linkAcademia
      brandImageUrl
      locales {
        id
        description
        __typename @skip(if: true)
      }
      menus
    }
  }
`
